<ng-container *ngIf="openStockItems.length > 0; else noItems"></ng-container>
<div *ngFor="let s of openStockItems">
    <hr />

    <div class="input-group" *ngIf="s.product">
        <span
            >{{ 'common.product' | translate }} <b>{{ s.product.identifier }}</b></span
        >
        <span>&nbsp;- {{ s.product.description }}</span>
    </div>
    <div class="input-group" *ngIf="s.lotNumber || s.storagePlace">
        <span [pTooltip]="s.storagePlace.name"
            >{{ 'common.warehouse' | translate }} {{ s.storagePlace.identifier }}</span
        >
        <span *ngIf="s.lotNumber && s.storagePlace">&nbsp;|&nbsp;</span>
        <span *ngIf="s.lotNumber"
            >{{ 'common.lot-number-short' | translate }} {{ s.lotNumber }}</span
        >
    </div>

    <div class="input-group" style="margin-top: 1pt">
        <!-- <div class="input-group-prepend">
            <button type="button" class="btn btn-outline-secondary" (click)="moreIsCollabsed = !moreIsCollabsed"
                [attr.aria-expanded]="!moreIsCollabsed" aria-controls="collapseBasic"><i class="fa fa-caret-down"></i>
                {{"common.more" | translate}}</button>
        </div> -->
        <div class="input-group-prepend">
            <span class="input-group-text input-group-in-stock"
                >{{ 'common.in-stock' | translate }}: <b>&nbsp;{{ s.quantity }}</b></span
            >
            <span class="input-group-text">{{ s.product.unit?.identifier }}</span>
        </div>
        <input
            #takeOverQuantityInput
            [ngModel]="model.takeOverQuantity"
            (ngModelChange)="takeOverQuantityChanged$.next({ osv: s, quantity: $event })"
            placeholder="{{ 'common.quantity' | translate }}"
            type="number"
        />
    </div>
</div>
<ng-template #noItems>
    <div *ngIf="loading" style="width: 100%; text-align: center; margin: 1em">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">{{ 'common.loading' | translate }}...</span>
        </div>
    </div>

    <span *ngIf="!loading"
        ><i> {{ 'warehouse.no-stock-available' | translate }}</i></span
    >
</ng-template>
